import * as React from "react";
import { forwardRef } from "react";
const SvgCheckIndeterminate = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 2, viewBox: "0 0 10 2", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1 2C0.716667 2 0.479 1.904 0.287 1.712C0.0956668 1.52067 0 1.28333 0 1C0 0.716667 0.0956668 0.479 0.287 0.287C0.479 0.0956664 0.716667 0 1 0H9C9.28333 0 9.52067 0.0956664 9.712 0.287C9.904 0.479 10 0.716667 10 1C10 1.28333 9.904 1.52067 9.712 1.712C9.52067 1.904 9.28333 2 9 2H1Z", fill: "white" }));
const ForwardRef = forwardRef(SvgCheckIndeterminate);
export default ForwardRef;
